import { Component, ReactNode } from 'react';
import { Table } from 'antd';
interface Props {
    columns?: any[],
    rows: any[],
    handleTableChange?: any,
    pagination: any,
    loading: boolean,
    scrolling: any,
    genericColumnsNames?: any,
    emptyText?: ReactNode,
    rowKey?: string | ((record: any) => string),
    size?: 'small' | 'middle' | 'large',
    bordered?: boolean,
}
class DataTable extends Component<Props> {
   
    render() {
        const { columns, rows, handleTableChange, pagination, loading, scrolling, emptyText, rowKey, size, bordered = true } = this.props;
        return <div style={{ maxWidth: "100%" }}>
            <Table
                columns={columns ? columns : this.props.genericColumnsNames}
                dataSource={rows}
                scroll={scrolling}
                onChange={handleTableChange}
                pagination={pagination}
                loading={loading}
                bordered={bordered}
                size={size}
                rowKey={rowKey}
                locale={emptyText ? { emptyText } : undefined}
            />
        </div>;
    }
}

export default DataTable;
